import SteveDescriptionModel from '@shell/plugins/steve/steve-description-class';

export default class RancherRegistration extends SteveDescriptionModel { }
